<script scoped>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      formData: {
        kategori: null,
        klasifikasi: null,
        batas_atas: 0,
        batas_bawah: 0,
        idklasifikasi_skor: null,
      },
    };
  },
  props: ["typeTrans", "dataKategori"],
  watch: {
    dataKategori: function (newVal) {
      if (newVal == null) {
        this.formData = {
          kategori: null,
          klasifikasi: null,
          batas_atas: 0,
          batas_bawah: 0,
          idklasifikasi_skor: null,
        };
      } else {
        this.formData = {
          kategori: newVal.kategori,
          klasifikasi: newVal.klasifikasi,
          batas_atas: newVal.batas_atas,
          batas_bawah: newVal.batas_bawah,
          idklasifikasi_skor: newVal.idklasifikasi_skor,
        };
      }
    },
  },
  emits: ["submitForm"],
  methods: {
    async submitForm() {
      if (!this.validateForm()) {
        return;
      }

      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      let payload = { ...this.formData };
      const url =
        this.typeTrans == "add"
          ? "master/klasifikasi-skor"
          : `master/klasifikasi-skor/${this.formData.idklasifikasi_skor}`;
      const method = this.typeTrans == "add" ? "post" : "put";
      const config = {
        method: method,
        url: process.env.VUE_APP_BACKEND_URL_VERSION + url,
        data: payload,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          "Content-type": "application/json",
        },
      };
      await axios(config)
        .then((response) => {
          console.log({ response });
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            console.log({ result });
            Swal.close();
            this.$emit("submitForm");
          });
        })
        .catch((error) => {
          console.log({ error });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response.data.data,
          });
        });
    },
    validateForm() {
      if (
        !this.formData.kategori ||
        !this.formData.klasifikasi ||
        this.formData.batas_atas === "" ||
        this.formData.batas_bawah === ""
      ) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Silahkan Lengkapi Data",
        });

        return false;
      }

      return true; // Form is valid
    },
  },
};
</script>

<template>
  <div class="container">
    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <div class="form-group mb-3">
        <label for="kategori" class="form-label">Kategori</label>
        <input
          v-model="formData.kategori"
          class="form-control"
          id="kategori"
          placeholder="Kategori..."
        />
      </div>
      <div class="form-group mb-3">
        <label for="klasifikasi" class="form-label">Klasifikasi</label>
        <input
          v-model="formData.klasifikasi"
          class="form-control"
          id="klasifikasi"
          placeholder="Klasifikasi..."
        />
      </div>
      <div class="form-group mb-3">
        <label for="batas_atas" class="form-label">Batas Atas</label>
        <input
          type="number"
          v-model="formData.batas_atas"
          class="form-control"
          id="batas_atas"
          placeholder="Batas Atas..."
        />
      </div>
      <div class="form-group mb-3">
        <label for="batas_bawah" class="form-label">Batas Bawah</label>
        <input
          type="number"
          v-model="formData.batas_bawah"
          class="form-control"
          id="batas_bawah"
          placeholder="Batas Bawah..."
        />
      </div>
      <div class="form-group float-end">
        <button class="btn btn-primary">
          <i class="fa fa-save"></i> Simpan
        </button>
      </div>
    </form>
  </div>
</template>
